import { useState, forwardRef } from 'react'
import { ThemeUIStyleObject } from 'theme-ui'
import { Input, InputProps } from 'components/Form'

type Props = Omit<InputProps, 'onChange' | 'value'> & {
  value: string
  onChange: (value: string) => void
  validate?: (value: string) => boolean
  sx?: ThemeUIStyleObject
}

export const SubtitleTimestampField = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, validate, sx, ...rest }, ref) => {
    const [localValue, setLocalValue] = useState(value)
    const [isValid, setIsValid] = useState(true)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const next = e.target.value
      setLocalValue(next)
      const valid = !validate || validate(next)
      setIsValid(valid)
      if (valid) {
        onChange(next)
      }
    }

    return (
      <Input
        ref={ref}
        value={localValue}
        onChange={handleChange}
        sx={{
          ...sx,
          ...(isValid
            ? {}
            : {
                borderColor: 'red',
                borderWidth: '1px',
                borderStyle: 'solid',
              }),
        }}
        {...rest}
      />
    )
  }
)
